const imagePath = '../assets/';
const configImages = {
  csv: require(`../assets/img/logo/csv.png`),
  xlsx: require(`../assets/img/logo/xlsx.png`),
  xls: require(`../assets/img/logo/xlsx.png`),
  ppt: require(`../assets/img/logo/ppt.jpg`),
  pdf: require(`../assets/img/logo/pdf.jpg`),
  json: require(`../assets/img/logo/json.jpg`),
  txt: require(`../assets/img/logo/txt.jpg`),
  docx: require(`../assets/img/logo/docx.jpg`),
  doc: require(`../assets/img/logo/docx.jpg`),
  defaultImg: require(`../assets/img/profile/defaultImg.png`),
  defaultUserImage: require(`../assets/img/profile/default_user_image.png`),
  employeesSampleXL: require(`../assets/files/scheduleSampleUpload.xlsx`),
  loginImage: require(`../assets/img/logo/21.png`),
  loginSideImage: require(`../assets/img/logo/1.png`),
  // loginLogo: require(`../assets/img/logo/loginLogo.jpg`),
  loaderImage: require(`../assets/loader.gif`),
  dosystemsImg : require('../assets/img/logo/1.png'),
  dosystemsWhiteLogo : require('../assets/img/logo/21.png'),
  topBarLogo : require('../assets/img/logo/31.png')

};
export default configImages;
